var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSymbolDefs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calculator",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M27.25 0h-22.5c-1.551 0-2.813 1.262-2.813 2.813v26.375c0 1.551 1.262 2.812 2.813 2.812h22.5c1.551 0 2.813-1.262 2.813-2.812v-26.375c0-1.551-1.262-2.813-2.813-2.813zM28.188 29.188c0 0.517-0.421 0.937-0.938 0.937h-22.5c-0.517 0-0.938-0.42-0.938-0.937v-26.375c0-0.517 0.421-0.938 0.938-0.938h22.5c0.517 0 0.938 0.421 0.938 0.938v26.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M25.375 3.75h-18.75c-0.518 0-0.938 0.42-0.938 0.938v7.625c0 0.518 0.42 0.938 0.938 0.938h18.75c0.518 0 0.937-0.42 0.937-0.938v-7.625c0-0.518-0.42-0.938-0.937-0.938zM24.437 11.375h-16.875v-5.75h16.875v5.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M10.375 15.125h-3.75c-0.518 0-0.938 0.42-0.938 0.938v3.75c0 0.518 0.42 0.938 0.938 0.938h3.75c0.518 0 0.938-0.42 0.938-0.938v-3.75c0-0.518-0.42-0.938-0.938-0.938zM9.438 18.875h-1.875v-1.875h1.875v1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M10.375 22.625h-3.75c-0.518 0-0.938 0.42-0.938 0.938v3.75c0 0.518 0.42 0.937 0.938 0.937h3.75c0.518 0 0.938-0.42 0.938-0.937v-3.75c0-0.518-0.42-0.938-0.938-0.938zM9.438 26.375h-1.875v-1.875h1.875v1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M17.875 15.125h-3.75c-0.518 0-0.938 0.42-0.938 0.938v3.75c0 0.518 0.42 0.938 0.938 0.938h3.75c0.518 0 0.937-0.42 0.937-0.938v-3.75c0-0.518-0.42-0.938-0.937-0.938zM16.937 18.875h-1.875v-1.875h1.875v1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M17.875 22.625h-3.75c-0.518 0-0.938 0.42-0.938 0.938v3.75c0 0.518 0.42 0.937 0.938 0.937h3.75c0.518 0 0.937-0.42 0.937-0.937v-3.75c0-0.518-0.42-0.938-0.937-0.938zM16.937 26.375h-1.875v-1.875h1.875v1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M25.375 15.125h-3.75c-0.518 0-0.937 0.42-0.937 0.938v11.25c0 0.518 0.42 0.937 0.937 0.937h3.75c0.518 0 0.937-0.42 0.937-0.937v-11.25c0-0.518-0.42-0.938-0.937-0.938zM24.437 26.375h-1.875v-9.375h1.875v9.375z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M27.961 3.307h-2.099v-0.514c0-0.518-0.42-0.938-0.937-0.938s-0.937 0.42-0.937 0.938v0.514h-2.587v-0.514c0-0.518-0.42-0.938-0.938-0.938s-0.937 0.42-0.937 0.938v0.514h-2.587v-0.514c0-0.518-0.42-0.938-0.937-0.938s-0.938 0.42-0.938 0.938v0.514h-2.587v-0.514c0-0.518-0.42-0.938-0.938-0.938s-0.938 0.42-0.938 0.938v0.514h-2.587v-0.514c0-0.518-0.42-0.938-0.938-0.938s-0.938 0.42-0.938 0.938v0.514h-2.099c-2.227 0-4.039 1.812-4.039 4.039v18.758c0 2.227 1.812 4.039 4.039 4.039h23.921c2.227 0 4.039-1.812 4.039-4.039v-18.758c0-2.227-1.812-4.039-4.039-4.039zM30.125 26.105c0 1.193-0.971 2.164-2.164 2.164h-23.921c-1.193 0-2.164-0.971-2.164-2.164v-15.333h28.25v15.333zM30.125 8.897h-28.25v-1.55c0-1.193 0.971-2.164 2.164-2.164h2.099v0.362c0 0.518 0.42 0.938 0.938 0.938s0.938-0.42 0.938-0.938v-0.362h2.587v0.362c0 0.518 0.42 0.938 0.938 0.938s0.938-0.42 0.938-0.938v-0.362h2.587v0.362c0 0.518 0.42 0.938 0.938 0.938s0.937-0.42 0.937-0.938v-0.362h2.587v0.362c0 0.518 0.42 0.938 0.937 0.938s0.938-0.42 0.938-0.938v-0.362h2.587v0.362c0 0.518 0.42 0.938 0.937 0.938s0.937-0.42 0.937-0.938v-0.362h2.099c1.193 0 2.164 0.971 2.164 2.164v1.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M10.451 12.771h-3.699c-0.518 0-0.938 0.42-0.938 0.938v3.827c0 0.518 0.42 0.938 0.938 0.938h3.699c0.518 0 0.938-0.42 0.938-0.938v-3.827c0-0.518-0.42-0.938-0.938-0.938zM9.513 16.598h-1.824v-1.952h1.824v1.952z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M17.85 12.771h-3.699c-0.518 0-0.938 0.42-0.938 0.938v3.827c0 0.518 0.42 0.938 0.938 0.938h3.699c0.518 0 0.937-0.42 0.937-0.938v-3.827c0-0.518-0.42-0.938-0.937-0.938zM16.912 16.598h-1.824v-1.952h1.824v1.952z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M25.248 12.771h-3.699c-0.518 0-0.937 0.42-0.937 0.938v3.827c0 0.518 0.42 0.938 0.937 0.938h3.699c0.518 0 0.937-0.42 0.937-0.938v-3.827c0-0.518-0.42-0.938-0.937-0.938zM24.311 16.598h-1.824v-1.952h1.824v1.952z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M10.451 20.041h-3.699c-0.518 0-0.938 0.42-0.938 0.937v3.827c0 0.518 0.42 0.938 0.938 0.938h3.699c0.518 0 0.938-0.42 0.938-0.938v-3.827c0-0.518-0.42-0.937-0.938-0.937zM9.513 23.869h-1.824v-1.952h1.824v1.952z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M17.85 20.041h-3.699c-0.518 0-0.938 0.42-0.938 0.937v3.827c0 0.518 0.42 0.938 0.938 0.938h3.699c0.518 0 0.937-0.42 0.937-0.938v-3.827c0-0.518-0.42-0.937-0.937-0.937zM16.912 23.869h-1.824v-1.952h1.824v1.952z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M25.248 20.041h-3.699c-0.518 0-0.937 0.42-0.937 0.937v3.827c0 0.518 0.42 0.938 0.937 0.938h3.699c0.518 0 0.937-0.42 0.937-0.938v-3.827c0-0.518-0.42-0.937-0.937-0.937zM24.311 23.869h-1.824v-1.952h1.824v1.952z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logout",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cbccd0",
    style: {
      fill: "var(--color2, #cbccd0)"
    },
    d: "M20 28h-16v-24h16v2h4v-6h-24v32h24v-6h-4v2h-0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cbccd0",
    style: {
      fill: "var(--color2, #cbccd0)"
    },
    d: "M24.586 8.586l-2.828 2.828 2.586 2.586h-10.344v4h10.344l-2.586 2.586 2.828 2.828 7.414-7.414-7.414-7.414z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash-can",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M28.992 7.153l-0.707-2.118c-0.269-0.807-1.021-1.349-1.871-1.349h-5.938v-1.933c0-0.966-0.786-1.753-1.752-1.753h-5.438c-0.966 0-1.752 0.786-1.752 1.753v1.933h-5.938c-0.85 0-1.603 0.542-1.872 1.349l-0.707 2.118c-0.161 0.482-0.079 1.016 0.218 1.428s0.778 0.659 1.286 0.659h0.739l1.625 20.1c0.121 1.491 1.386 2.66 2.882 2.66h12.804c1.495 0 2.761-1.169 2.882-2.66l1.625-20.1h0.409c0.508 0 0.989-0.246 1.286-0.658s0.379-0.947 0.218-1.429zM13.41 1.875h5.191v1.811h-5.191v-1.811zM23.585 29.189c-0.043 0.525-0.487 0.936-1.013 0.936h-12.804c-0.525 0-0.97-0.411-1.013-0.936l-1.614-19.949h18.056l-1.613 19.949zM4.924 7.365l0.579-1.737c0.013-0.040 0.051-0.067 0.093-0.067h20.818c0.042 0 0.079 0.027 0.093 0.067l0.579 1.737h-22.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M20.595 29.122c0.017 0.001 0.033 0.001 0.050 0.001 0.495 0 0.909-0.388 0.935-0.889l0.88-16.9c0.027-0.517-0.371-0.958-0.887-0.985-0.518-0.028-0.958 0.37-0.985 0.887l-0.88 16.9c-0.027 0.517 0.37 0.958 0.887 0.985z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M10.473 28.237c0.027 0.5 0.441 0.886 0.935 0.886 0.017 0 0.035-0 0.052-0.001 0.517-0.028 0.913-0.47 0.885-0.987l-0.922-16.9c-0.028-0.517-0.47-0.913-0.987-0.885s-0.913 0.47-0.885 0.987l0.922 16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M16.016 29.124c0.518 0 0.938-0.42 0.938-0.938v-16.9c0-0.518-0.42-0.938-0.938-0.938s-0.938 0.42-0.938 0.938v16.9c0 0.518 0.42 0.938 0.938 0.938z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-left",
    viewBox: "0 0 48 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff751d",
    style: {
      fill: "var(--color3, #ff751d)"
    },
    d: "M48 13.333h-37.787l9.547-9.573-3.76-3.76-16 16 16 16 3.76-3.76-9.547-9.573h37.787v-5.333z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-to-down",
    viewBox: "0 0 55 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c7ccdc",
    style: {
      stroke: "var(--color4, #c7ccdc)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 9.1429,
    d: "M4.571 4.571l23.343 18.286 23.344-18.286"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-right",
    viewBox: "0 0 19 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff751d",
    style: {
      stroke: "var(--color3, #ff751d)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 5.3333,
    d: "M2.667 2.667l10.667 13.333-10.667 13.333"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-three-sticks-vertically",
    viewBox: "0 0 37 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#52555f",
    style: {
      fill: "var(--color1, #52555f)"
    },
    d: "M6.737 7.074h5.053v16.505h-5.053v-16.505zM16.168 0h4.716v23.579h-4.716v-23.579zM25.6 13.474h4.716v10.105h-4.716v-10.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    style: {
      stroke: "var(--color5, #000)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.6842,
    d: "M7.579 7.916h3.368v14.821h-3.368v-14.821zM17.011 0.842h3.032v21.895h-3.032v-21.895zM26.442 14.316h3.032v8.421h-3.032v-8.421z"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-long-arrow-left",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5H3.83L7.41 1.41L6 0L0 6L6 12L7.41 10.59L3.83 7H18V5Z",
    fill: "#FF751D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolDefs);
export default __webpack_public_path__ + "static/media/symbol-defs.534bebcbc4b4afee3b1f34c43ba3f158.svg";
export { ForwardRef as ReactComponent };